<template>
  <div>
    <v-container fluid>
      <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
        <!-- <v-toolbar-title class="title">Data Integration Detail</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="title">{{ today }}</v-toolbar-title> -->
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Data Integration Detail</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row class="mb-4">
            <v-col cols="12" sm="12" md="5">
              <v-sheet class="integration-name-sheet" elevation="0" rounded>
                <div class="d-flex align-center">
                  <v-icon color="primary" size="28" class="mr-4"
                    >mdi-database</v-icon
                  >
                  <div class="flex-grow-1">
                    <div class="integration-name-label-simple">
                      Data Integration Name
                    </div>
                    <div class="integration-name-value-simple">
                      {{ DataIntegrationName || "-" }}
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-col>
          </v-row>
          <v-expansion-panels
            multiple
            accordion
            flat
            dense
            v-model="panel"
            class="expan-Pannel"
          >
            <v-expansion-panel>
              <v-expansion-panel-title
                id="detail-Configuration-dataintegration"
                class="custom-expansion-title"
              >
                <template v-slot:actions="{ expanded }">
                  <v-icon
                    :style="{
                      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    }"
                    class="expansion-icon"
                  >
                    mdi-chevron-down
                  </v-icon>
                </template>
                <div class="expansion-title-content">
                  <v-icon color="primary" class="mr-3">mdi-cog</v-icon>
                  <span class="expansion-header">Configuration</span>
                </div>
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <div class="configuration-container">
                  <!-- Configuration Cards -->

                  <!-- Effective Date Configuration -->
                  <v-row class="mt-6 mb-4">
                    <v-col cols="12">
                      <v-card class="config-card" elevation="1" rounded="lg">
                        <v-card-text class="config-card-content">
                          <div class="config-header">
                            <v-icon color="primary" size="20" class="mr-2"
                              >mdi-calendar-range</v-icon
                            >
                            <span class="config-title">Effective Date Configuration</span>
                          </div>

                          <v-row class="config-fields" no-gutters>
                            <!-- Effective Start Date -->
                            <v-col cols="12" md="6" class="field-col pr-3">
                              <v-menu
                                v-model="effectiveStartDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                location="bottom start"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ props }">
                                  <v-text-field
                                    id="detail-effective-start-date"
                                    :model-value="formattedEffectiveStartDate"
                                    label="Effective Start Date"
                                    prepend-inner-icon="mdi-calendar-start"
                                    readonly
                                    variant="outlined"
                                    density="compact"
                                    clearable
                                    @click:clear="effectiveStartDate = null"
                                    v-bind="props"
                                    hide-details
                                    class="config-field"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="effectiveStartDate"
                                  :max="effectiveEndDate"
                                  :format="'dd/MM/yyyy HH:mm'"
                                  @update:model-value="effectiveStartDateMenu = false"
                                  elevation="8"
                                  rounded="lg"
                                  class="modern-date-picker"
                                />
                              </v-menu>
                            </v-col>

                            <!-- Effective End Date -->
                            <v-col cols="12" md="6" class="field-col pl-3">
                              <v-menu
                                v-model="effectiveEndDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                location="bottom start"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ props }">
                                  <v-text-field
                                    id="detail-effective-end-date"
                                    :model-value="formattedEffectiveEndDate"
                                    label="Effective End Date"
                                    prepend-inner-icon="mdi-calendar-end"
                                    readonly
                                    variant="outlined"
                                    density="compact"
                                    clearable
                                    @click:clear="effectiveEndDate = null"
                                    v-bind="props"
                                    hide-details
                                    class="config-field"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="effectiveEndDate"
                                  :min="effectiveStartDate"
                                  :format="'dd/MM/yyyy HH:mm'"
                                  @update:model-value="effectiveEndDateMenu = false"
                                  elevation="8"
                                  rounded="lg"
                                  class="modern-date-picker"
                                />
                              </v-menu>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <div
                    v-for="(item, index) in DataCol"
                    :key="index"
                    class="config-card-wrapper"
                  >
                    <v-card class="config-card" elevation="1" rounded="lg">
                      <v-card-text class="config-card-content">
                        <div class="config-header">
                          <v-icon color="primary" size="20" class="mr-2"
                            >mdi-view-column</v-icon
                          >
                          <span class="config-title"
                            >Column {{ index + 1 }}</span
                          >
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="type == 'E' || !item.col"
                            :id="
                              'detail-E-button-DeleteAction-dataintegration-' +
                              index
                            "
                            variant="text"
                            size="small"
                            color="error"
                            icon
                            @click="DeleteAction(index)"
                            class="config-delete-btn"
                          >
                            <v-icon size="18">mdi-delete</v-icon>
                          </v-btn>
                        </div>

                        <v-row class="config-fields" no-gutters>
                          <!-- Column Name Field -->
                          <v-col cols="12" md="6" class="field-col pr-3">
                            <v-text-field
                              :id="
                                'detail-configuration-column-dataintegration-' +
                                index
                              "
                              :label="$t('_columnDataIntegration')"
                              v-model="item.newCol"
                              variant="outlined"
                              density="compact"
                              class="config-field"
                              :error="errorMessages.columns[index]?.error"
                              :error-messages="errorMessages.columns[index]?.message"
                            />
                          </v-col>
                          <!-- Data Type Field -->
                          <v-col
                            cols="12"
                            md="6"
                            v-if="type == 'I'"
                            class="field-col pl-3"
                          >
                            <v-autocomplete
                              :id="
                                'detail-I-configuration-datatype-dataintegration-' +
                                index
                              "
                              :label="$t('_typeDataIntegration')"
                              :items="DDDataType"
                              item-title="name"
                              item-value="id"
                              clearable
                              density="compact"
                              variant="outlined"
                              v-model="item.typeId"
                              @update:model-value="setDefault(item)"
                              hide-details
                              class="config-field"
                            />
                          </v-col>
                        </v-row>

                        <div class="fuzzy-personal-container">
                          <v-row no-gutters>
                            <v-col cols="12" sm="6" style="display: flex;">
                              <!-- Fuzzy Dropdown -->
                              <div class="fuzzy-dropdown-wrapper">
                                <v-select
                                  :items="fuzzyOptions"
                                  item-title="text"
                                  item-value="value"
                                  :model-value="getFuzzyValue(item)"
                                  @update:model-value="
                                    setFuzzyValue(item, $event)
                                  "
                                  :disabled="item.typeId != 'nvarchar' && item.typeId != 'varchar' && item.typeId != 'varchar2' && item.typeId != 'text' 
                                    && item.typeId != 'char' && item.typeId != 'nchar' && item.typeId != 'VARCHAR2' && item.typeId != 'TEXT'
                                    && item.typeId != 'CHAR' && item.typeId != 'NCHAR' && item.typeId != 'NVARCHAR2'"
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  class="fuzzy-select"
                                >
                                  <template
                                    v-slot:selection="{ item: selectedItem }"
                                  >
                                    <div class="selection-content">
                                      <v-icon
                                        :color="getFuzzyColor(selectedItem.raw)"
                                        size="16"
                                        class="mr-2"
                                      >
                                        {{ getFuzzyIcon(selectedItem.raw) }}
                                      </v-icon>
                                      <span class="selection-text">{{
                                        selectedItem.raw.text
                                      }}</span>
                                    </div>
                                  </template>

                                  <template
                                    v-slot:item="{ props, item: dropdownItem }"
                                  >
                                    <v-list-item
                                      v-bind="props"
                                      class="fuzzy-list-item"
                                    >
                                      <template v-slot:prepend>
                                        <v-icon
                                          :color="
                                            getFuzzyColor(dropdownItem.raw)
                                          "
                                          size="18"
                                        >
                                          {{ getFuzzyIcon(dropdownItem.raw) }}
                                        </v-icon>
                                      </template>

                                      <v-list-item-subtitle
                                        class="fuzzy-item-subtitle"
                                      >
                                        {{ dropdownItem.raw.description }}
                                      </v-list-item-subtitle>
                                    </v-list-item>
                                  </template>

                                  <template v-slot:label>
                                    <div class="label-content">
                                      <v-icon
                                        size="16"
                                        class="mr-2"
                                        color="primary"
                                        >mdi-tune</v-icon
                                      >
                                      <span>Fuzzy Matching</span>
                                    </div>
                                  </template>
                                </v-select>
                              </div>
                              <div
                                v-if="type == 'E' && (item.typeId == '' || item.typeId == null)"
                                @click="validateColumnNameAndType(index)"
                                class="validate-button"
                              >
                                <v-icon class="mr-2">mdi-refresh-circle</v-icon>
                                Validate Column
                              </div>
                            </v-col>

                            <!-- Personal Information Switch -->
                            <v-col cols="12" sm="6">
                              <div class="personal-info-wrapper">
                                <div class="personal-info-container">
                                  <div class="personal-info-header">
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <div
                                          class="personal-info-label"
                                          v-bind="props"
                                        >
                                          <v-icon
                                            size="16"
                                            color="warning"
                                            class="mr-1"
                                            >mdi-shield-account</v-icon
                                          >
                                          <span class="text-caption">
                                            Personal Info:
                                            <span
                                              :class="
                                                item.personalInformation
                                                  ? 'status-on'
                                                  : 'status-off'
                                              "
                                            >
                                              {{
                                                item.personalInformation
                                                  ? "ON"
                                                  : "OFF"
                                              }}
                                            </span>
                                          </span>
                                        </div>
                                      </template>
                                      <span>{{ $t("_Personal_Info") }}</span>
                                    </v-tooltip>

                                    <v-switch
                                      v-model="item.personalInformation"
                                      inset
                                      density="compact"
                                      color="warning"
                                      hide-details
                                      class="personal-info-switch"
                                      :disabled="
                                      (item.typeId == '' || item.typeId == null)
                                      ||
                                        item.typeId != null &&
                                        item.typeId.toLowerCase() !=
                                          'nvarchar' &&
                                        item.typeId.toLowerCase() != 'text' &&
                                        item.typeId.toLowerCase() !=
                                          'varchar' &&
                                        item.typeId.toLowerCase() !=
                                          'varchar2' &&
                                        item.typeId.toLowerCase() != 'char' &&
                                        item.typeId.toLowerCase() != 'nchar'
                                      "
                                    ></v-switch>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <!-- Add Column Button -->
                  <v-row class="add-column-row">
                    <v-col cols="12" md="6">
                      <v-btn
                        v-if="canAdd"
                        id="detail-E-button-addcolumn-dataitegration"
                        variant="outlined"
                        color="primary"
                        block
                        @click="AddColumn()"
                        class="add-column-btn"
                      >
                        <v-icon class="mr-2">mdi-plus-circle</v-icon>
                        Add Column
                        <v-tooltip location="top" activator="parent">
                          <span v-if="type == 'E'"
                            >เพิ่มเฉพาะ Column ที่ต้องการ(ไม่จำเป็นต้องใช้ทุฝ
                            Column ที่มีอยู่ใน Table)</span
                          >
                          <span v-else>เพิ่ม Column ใหม่ลงในตาราง</span>
                        </v-tooltip>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Action Buttons -->
                  <div class="config-action-buttons">
                    <v-btn
                      id="detail-button-close-dataitegration"
                      variant="text"
                      color="grey-darken-1"
                      @click="back()"
                      class="config-action-btn"
                    >
                      <v-icon class="mr-1">mdi-close</v-icon>
                      {{ $t("close") }}
                    </v-btn>
                    <v-btn
                      v-if="canEdit || canAdd"
                      id="detail-button-save-dataitegration"
                      variant="elevated"
                      @click="Save()"
                      class="config-action-btn save-btn ml-4"
                    >
                      <v-icon class="mr-1">mdi-content-save</v-icon>
                      {{ $t("save") }}
                    </v-btn>
                  </div>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-title
                id="detail-data-dataintegration"
                class="custom-expansion-title"
              >
                <template v-slot:actions="{ expanded }">
                  <v-icon
                    :style="{
                      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    }"
                    class="expansion-icon"
                  >
                    mdi-chevron-down
                  </v-icon>
                </template>
                <div class="expansion-title-content">
                  <v-icon color="primary" class="mr-3">mdi-table-large</v-icon>
                  <span class="expansion-header">Data</span>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row>
                  <v-col cols="3" v-if="DataCol.length > 0 && type == 'I'">
                    <!-- Search Field Container -->
                    <div class="search-field-container">
                      <!-- Float Type Search -->
                      <v-text-field
                        v-if="DataCol[0].typeId == 'float' && type == 'I'"
                        :label="
                          DataCol.length > 0 ? DataCol[0].newCol : 'Search'
                        "
                        v-model="Search"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                        class="search-field"
                        placeholder="Search"
                        @keypress="isNumber($event)"
                      />

                      <!-- Integer Type Search -->
                      <v-text-field
                        id="detail-I-fieldShearch-dataintegration"
                        v-else-if="DataCol[0].typeId == 'int' && type == 'I'"
                        :label="
                          DataCol.length > 0 ? DataCol[0].newCol : 'Search'
                        "
                        v-model="Search"
                        variant="outlined"
                        density="compact"
                        placeholder="Search"
                        clearable
                        hide-details="auto"
                        class="search-field"
                        @keypress="isNumberpositive($event)"
                      />

                      <!-- String/Bit Type Search -->
                      <v-text-field
                        v-else-if="
                          (DataCol[0].typeId == 'nvarchar' ||
                            DataCol[0].typeId == 'bit') &&
                          type == 'I'
                        "
                        :label="
                          DataCol.length > 0 ? DataCol[0].newCol : 'Search'
                        "
                        v-model="Search"
                        variant="outlined"
                        density="compact"
                        placeholder="Search"
                        clearable
                        hide-details="auto"
                        class="search-field"
                      />

                      <!-- DateTime Type Search -->
                      <v-menu
                        v-model="AddDateFlag"
                        v-else-if="
                          DataCol[0].typeId == 'datetime' && type == 'I'
                        "
                        :close-on-content-click="false"
                        transition="scale-transition"
                        location="bottom start"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            id="detail-search-dataintegration"
                            v-model="Search"
                            :label="
                              DataCol.length > 0 ? DataCol[0].newCol : 'Search'
                            "
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            density="compact"
                            clearable
                            hide-details="auto"
                            v-bind="props"
                            class="search-field date-field"
                          />
                        </template>
                        <v-date-picker
                          id="detail-button-search-dataintegration"
                          v-model="Search"
                          @update:model-value="
                            (val) => {
                              Search = formatDate(val);
                              AddDateFlag = false;
                            }
                          "
                          elevation="8"
                          rounded="lg"
                        />
                      </v-menu>
                    </div>
                  </v-col>

                  <v-row>
                    <v-col cols="6" v-if="type == 'I'">
                      <div
                        class="search-action-container"
                        style="margin-top: 20px; margin-left: -15px"
                      >
                        <v-btn
                          id="detail-I-button-getsearch-dataintegration"
                          color="primary"
                          variant="elevated"
                          size="default"
                          class="search-btn compact"
                          @click="GetSearch()"
                        >
                          <v-icon class="mr-1" size="18">mdi-magnify</v-icon>
                          Search
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      class="d-flex justify-end"
                      v-if="type == 'I'"
                    >
                      <div class="control-group" style="margin-top: -25px">
                        <v-select
                          id="detail-processtype-dataintegration"
                          :label="$t('process_type')"
                          :items="filteredModeType"
                          item-title="name"
                          item-value="value"
                          variant="outlined"
                          v-model="deleteAll"
                          :disabled="filteredModeType.length <= 1"
                          style="margin-top: 20px"
                          density="compact"
                          class="process-type-select"
                        >
                          <template v-slot:append-inner>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  color="info"
                                  v-bind="props"
                                  class="info-icon"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("_InfoProcess_type") }}</span>
                            </v-tooltip>
                          </template>
                        </v-select>

                        <v-btn
                          id="detail-button-upload-proxy"
                          variant="elevated"
                          class="upload-proxy-btn"
                          :disabled="!canAdd && !canEdit"
                          @click="triggerFileUpload"
                        >
                          <v-icon class="mr-2">mdi-file-upload</v-icon>
                          Upload Excel
                        </v-btn>

                        <!-- Hidden DragDropFile Component -->
                        <DragDropFile
                          ref="dragDropFileRef"
                          id="detail-button-uploadfile-dataintegration"
                          :dialog="true"
                          :DragDrop="false"
                          :ShowListFile="false"
                          :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                          @filesUploaded="processUpload($event)"
                          :allowType="[]"
                          class="upload-file-btn hidden-upload"
                        />
                        <div v-if="canAdd" class="add-action-container">
                          <v-btn
                            id="detail-I-button-adddata-dataintegration"
                            color="success"
                            variant="elevated"
                            size="large"
                            class="add-btn"
                            @click="Adddialog = true"
                          >
                            <v-icon class="mr-2">mdi-plus-circle</v-icon>
                            {{ $t("add") }}
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-card elevation="2" class="data-table-card">
                      <v-card-title class="table-header">
                        <v-icon
                          left
                          color="primary"
                          style="margin-right: 5px; margin-top: -5px"
                          >mdi-table-large</v-icon
                        >
                        <span
                          class="text-h6 font-weight-medium"
                          style="margin-right: 20px"
                          >Data Table</span
                        >
                        <v-chip
                          v-if="searchTotalTable > 0"
                          color="primary"
                          variant="outlined"
                          size="small"
                        >
                          {{ searchTotalTable }} {{ $t("records") }}
                        </v-chip>
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-data-table
                        :items-per-page="options.itemsPerPage"
                        :loading="loadingTable"
                        :items-length="searchTotalTable"
                        v-model:options="options"
                        :headers="headers"
                        :items="dataTable"
                        class="modern-table"
                        :hover="true"
                        :fixed-header="true"
                      >
                        <!-- Loading Template -->
                        <template v-slot:loading>
                          <v-skeleton-loader
                            type="table-row@10"
                          ></v-skeleton-loader>
                        </template>

                        <!-- No Data Template -->
                        <template v-slot:no-data>
                          <div class="text-center pa-8">
                            <v-icon size="64" color="grey-lighten-2"
                              >mdi-database-off</v-icon
                            >
                            <div class="text-h6 text-grey-darken-1 mt-4">
                              No data available
                            </div>
                            <div class="text-body-2 text-grey">
                              Try different search
                            </div>
                          </div>
                        </template>

                        <!-- Header Template -->
                        <template v-slot:headers="{ columns }">
                          <tr class="table-header-row">
                            <th
                              v-for="column in columns"
                              :key="column.key"
                              class="table-header-cell"
                              :class="{
                                'text-center': column.align === 'center',
                              }"
                            >
                              <div class="header-content">
                                <span class="header-text">{{
                                  column.title
                                }}</span>
                              </div>
                            </th>
                          </tr>
                        </template>

                        <!-- Item Template -->
                        <template v-slot:item="{ item, index }">
                          <tr
                            :key="index + 'tr'"
                            class="table-row"
                            :class="{ 'row-hover': true }"
                          >
                            <td
                              v-for="(value, i) in item"
                              :key="i + 'td'"
                              class="table-cell"
                              :class="{
                                'text-center': headers[i]?.align === 'center',
                              }"
                            >
                              <div class="cell-content">
                                <span class="cell-text" :title="value">
                                  {{ value }}
                                </span>
                              </div>
                            </td>

                            <!-- Action Column -->
                            <td
                              v-if="type == 'I'"
                              class="table-cell text-center action-cell"
                            >
                              <div class="action-buttons">
                                <v-btn
                                  :id="
                                    'detail-I-button-editdata-dataintegration-' +
                                    index
                                  "
                                  variant="text"
                                  class="datatable-action-btn edit-btn"
                                  v-bind="props"
                                  @click="EditData(item)"
                                >
                                  <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                                </v-btn>
                                <div v-if="canDelete" class="action-divider"></div>

                                <v-tooltip v-if="canDelete" location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-btn
                                      :id="
                                        'detail-I-button-deletedata-dataintegration-' +
                                        index
                                      "
                                      variant="text"
                                      class="datatable-action-btn delete-btn"
                                      v-bind="props"
                                      @click="DeleteData(item)"
                                    >
                                      <v-icon size="18"
                                        >mdi-delete-outline</v-icon
                                      >
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("delete") }}</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                        </template>

                        <!-- Custom Footer for v-data-table -->
                        <template v-slot:bottom>
                          <div class="custom-footer">
                            <div class="footer-left">
                              <span>Items per page:</span>
                              <v-select
                                v-model="options.itemsPerPage"
                                :items="[5, 10, 15, 20]"
                                dense
                                hide-details
                                variant="outlined"
                                density="compact"
                                style="width: 100px; margin-left: 8px"
                              ></v-select>
                            </div>
                            <div class="footer-center">
                              <span>
                                {{
                                  (options.page - 1) * options.itemsPerPage + 1
                                }}-
                                {{
                                  Math.min(
                                    options.page * options.itemsPerPage,
                                    searchTotalTable
                                  )
                                }}
                                of {{ searchTotalTable }}
                              </span>
                            </div>
                            <div class="footer-right">
                              <div
                                style="
                                  background-color: transparent !important;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="options.page = 1"
                                  :disabled="options.page === 1"
                                  :class="
                                    options.page === 1
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-page-first</v-icon
                                >
                              </div>
                              <div
                                style="
                                  background-color: transparent;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="options.page--"
                                  :disabled="options.page === 1"
                                  :class="
                                    options.page === 1
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-chevron-left</v-icon
                                >
                              </div>
                              <div
                                style="
                                  background-color: transparent;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="options.page++"
                                  :disabled="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                  "
                                  :class="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-chevron-right</v-icon
                                >
                              </div>
                              <div
                                style="
                                  background-color: transparent;
                                  box-shadow: none;
                                "
                                icon
                              >
                                <v-icon
                                  style="min-width: 50px"
                                  @click="
                                    options.page = Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                  "
                                  :disabled="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                  "
                                  :class="
                                    options.page >=
                                    Math.ceil(
                                      searchTotalTable / options.itemsPerPage
                                    )
                                      ? 'transparent-disabled'
                                      : 'transparent-enabled'
                                  "
                                  >mdi-page-last</v-icon
                                >
                              </div>
                            </div>
                          </div>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <br />
      </v-card>
    </v-container>
    <v-dialog v-model="Adddialog" max-width="1200" persistent class="modern-dialog">
      <v-card class="dialog-card" elevation="8" rounded="xl">
        <!-- Enhanced Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="28" color="white">mdi-plus-circle</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title" style="color: white;">{{ $t('add') }}</h2>
              <p class="dialog-subtitle" style="color: white;">Add new data to your integration</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              class="close-button"
              @click="
                Adddialog = false;
                NewDataDetail = [];
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

        </div>

        <!-- Enhanced Content -->
        <v-card-text class="modern-dialog-content">
          <div class="form-container">
            <v-row class="form-grid">
              <v-col
                cols="12"
                sm="12"
                md="6"
                v-for="(item, id) in DataCol"
                :key="id"
                class="form-column"
              >
                <!-- Field Container -->
                <div class="field-container">
                  <!-- Float Type Field -->
                  <v-text-field
                    v-if="item.typeId == 'float'"
                    :id="'detail-newdatatype-float-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-numeric"
                    @keypress="isNumber($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Integer Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'int'"
                    :id="'detail-newdatatype-int-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-pound"
                    @keypress="isNumberpositive($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Text Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'nvarchar'"
                    :id="'detail-newdatatype-nvarchar-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-format-text"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Boolean Select Field -->
                  <v-select
                    v-else-if="item.typeId == 'bit'"
                    :id="'detail-newdatatype-bit-dataintegration' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    :items="[
                      { text: 'True', value: 'True' },
                      { text: 'False', value: 'False' },
                    ]"
                    item-title="text"
                    item-value="value"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-toggle-switch"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Date Field -->
                  <v-menu
                    v-else-if="item.typeId == 'datetime'"
                    :id="'detail-newdatatype-date-dataintegration-' + id"
                    v-model="AddDateFlag"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    location="bottom start"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="NewDataDetail[id]"
                        :label="item.newCol"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        clearable
                        v-bind="props"
                        class="modern-field date-field"
                        :rules="[rules.required]"
                        hide-details="auto"
                      />
                    </template>
                    <v-date-picker
                      id="detail-button-addDateFlag-dataintegration"
                      v-model="NewDataDetail[id]"
                      format="yyyy-MM-dd"
                      @update:model-value="
                        (val) => {
                          NewDataDetail[id] = formatDate(val);
                          AddDateFlag = false;
                        }
                      "
                      elevation="8"
                      rounded="lg"
                      class="modern-date-picker"
                    />
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <!-- Enhanced Divider -->
        <v-divider class="modern-divider"></v-divider>

        <!-- Enhanced Actions -->
        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn
                id="detail-button-close-datadetail-dataintegration"
                variant="outlined"
                color="grey-darken-1"
                size="large"
                class="dialog-action-btn cancel-btn"
                @click="
                  Adddialog = false;
                  NewDataDetail = [];
                "
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t('close') }}
              </v-btn>
              
              <v-btn
                v-if="canAdd"
                id="detail-button-saveadddetail-dataintegration"
                variant="elevated"

                size="large"
                class="dialog-action-btn save-btn-add"
                @click="SaveAddDetail()"
              >
                <v-icon class="mr-2">mdi-content-save</v-icon>
                {{ $t('save') }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="Editdialog" max-width="1200" persistent class="modern-dialog">
      <v-card class="dialog-card" elevation="8" rounded="xl">
        <!-- Enhanced Header -->
        <v-card-title class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="28" color="white">{{ canEdit ? 'mdi-pencil' : 'mdi-eye-outline' }}</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title" style="color: white">{{ canEdit ? $t('edit') : $t('view') }}</h2>
              <p class="dialog-subtitle" style="color: white">{{ canEdit ? 'Edit existing data record' : 'View existing data record' }}</p>
            </div>
          </div>
        </v-card-title>

        <!-- Enhanced Content -->
        <v-card-text class="modern-dialog-content">
          <div class="form-container">
            <v-row class="form-grid">
              <v-col
                cols="12"
                sm="12"
                md="6"
                v-for="(item, id) in DataCol"
                :key="id"
                class="form-column"
              >
                <!-- Field Container -->
                <div class="field-container">
                  <!-- Float Type Field -->
                  <v-text-field
                    v-if="item.typeId == 'float'"
                    :id="'detail-editdatatype-float-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-numeric"
                    @keypress="isNumber($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Integer Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'int'"
                    :id="'detail-editdatatype-int-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-pound"
                    @keypress="isNumberpositive($event)"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Text Type Field -->
                  <v-text-field
                    v-else-if="item.typeId == 'nvarchar'"
                    :id="'detail-editdatatype-nvarchar-dataintegration-' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-format-text"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Boolean Select Field -->
                  <v-select
                    v-else-if="item.typeId == 'bit'"
                    :id="'detail-editdatatype-bit-dataintegration' + id"
                    :label="item.newCol"
                    v-model="NewDataDetail[id]"
                    :items="[
                      { text: 'True', value: 'True' },
                      { text: 'False', value: 'False' },
                    ]"
                    item-title="text"
                    item-value="value"
                    variant="outlined"
                    density="comfortable"
                    class="modern-field"
                    prepend-inner-icon="mdi-toggle-switch"
                    :rules="[rules.required]"
                    hide-details="auto"
                  />

                  <!-- Date Field -->
                  <v-menu
                    v-else-if="item.typeId == 'datetime'"
                    :id="'detail-editdatatype-date-dataintegration-' + id"
                    v-model="EditDateFlag"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    location="bottom start"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        v-model="NewDataDetail[id]"
                        :label="item.newCol"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        variant="outlined"
                        density="comfortable"
                        clearable
                        v-bind="props"
                        class="modern-field date-field"
                        :rules="[rules.required]"
                        hide-details="auto"
                      />
                    </template>

                    <v-date-picker
                      v-model="NewDataDetail[id]"
                      format="YYYY-MM-DD"
                      @update:model-value="
                        (val) => {
                          NewDataDetail[id] = formatDate(val);
                          EditDateFlag = false;
                        }
                      "
                      elevation="8"
                      rounded="lg"
                      class="modern-date-picker"
                    />
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <!-- Enhanced Divider -->
        <v-divider class="modern-divider"></v-divider>

        <!-- Enhanced Actions -->
         <div class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn
              variant="outlined"
              color="grey-darken-1"
              size="large"
              class="dialog-action-btn cancel-btn"
              @click="
                Editdialog = false;
                NewDataDetail = [];
              "
            >
              <v-icon class="mr-2">mdi-close</v-icon>
              {{ $t("close") }}
            </v-btn>
              <v-btn
              v-if="canEdit"
              variant="elevated"
              color="primary"
              size="large"
              class="dialog-action-btn save-btn-edit"
              @click="SaveEdit()"
            >
              <v-icon class="mr-2">mdi-content-save</v-icon>
              {{ $t("save") }}
            </v-btn>
            </div>
          </div>
         </div>
      </v-card>
    </v-dialog>
    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <!-- Custom Confirmation Dialog -->
    <v-dialog v-model="confirmDialog.show" max-width="550" persistent class="confirm-dialog">
      <v-card class="confirm-card" elevation="8" rounded="xl">
        <!-- Header -->
        <v-card-title class="confirm-header" :class="confirmDialog.type + '-header'">
          <div class="confirm-icon-container">
            <v-icon 
              size="32" 
              color="white"
              :icon="getConfirmIcon(confirmDialog.type)"
            ></v-icon>
          </div>
          <div class="confirm-title-text">
            <h3>{{ confirmDialog.title }}</h3>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="confirm-content" v-if="confirmDialog.text">
          <p class="confirm-message">{{ confirmDialog.text }}</p>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="confirm-actions" v-if="!confirmDialog.autoClose">
          <v-spacer></v-spacer>
          <v-btn
            v-if="confirmDialog.showCancel"
            variant="outlined"
            color="grey-darken-1"
            class="confirm-btn cancel-btn"
            @click="handleConfirmCancel"
          >
            <v-icon class="mr-2">mdi-close</v-icon>
            {{ confirmDialog.cancelText || $t('cancel') }}
          </v-btn>
          <v-btn
            variant="elevated"
            :color="getConfirmColor(confirmDialog.type)"
            class="confirm-btn confirm-btn-primary"
            @click="handleConfirmOk"
          >
            <v-icon class="mr-2">{{ getConfirmActionIcon(confirmDialog.type) }}</v-icon>
            {{ confirmDialog.confirmText || $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import DragDropFile from "@/components/DragDropFile.vue";
import ExcelJS from "exceljs";

import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import { color } from "highcharts";

export default {
  name: "DataIntegrationDetail",
  components: { DragDropFile },
  mixins: [checkPermissionTwo],
  inject:["FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    allowOptionWatch: false,
    options: {},
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    headers: [],
    Search: "",
    id: null,
    panel: [1],
    dialog: false,
    loadingTable: false,
    Adddialog: false,
    Editdialog: false,
    AddDateFlag: false,
    EditDateFlag: false,
    // valid: true,
    // tempID: 0,
    today: null,
    loading: true,
    DataCol: [],
    DataIntegrationName: null,
    OldDataDetail: [],
    NewDataDetail: [],
    type: null,
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    DataRowUpload: [],
    fuzzyOptions: [
      {
        text: "None",
        value: "none",
        description: "No fuzzy matching applied",
        icon: "mdi-close-circle-outline",
        color: "grey",
      },
      {
        text: "Fuzzy Search",
        value: "fuzzy",
        description: "Enable approximate text matching for this column",
        icon: "mdi-magnify",
        color: "primary",
      },
      {
        text: "Fuzzy with Bot",
        value: "fuzzyBot",
        description: "AI-powered smart matching with enhanced accuracy",
        icon: "mdi-robot",
        color: "success",
      },
    ],
    rules: {
      required: (value) => !!value || "Required.",
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    DDDataType: [
      {
        id: "nvarchar",
        name: "nvarchar",
      },
      {
        id: "int",
        name: "int",
      },
      {
        id: "float",
        name: "float",
      },
      {
        id: "datetime",
        name: "datetime",
      },
      {
        id: "bit",
        name: "bit",
      },
    ],
    modeType: [
      {
        name: "Add",
        value: false,
      },
      {
        name: "Replace",
        value: true,
      },
    ],
    deleteAll: false,
    Entity: null,
    uploadedFiles: [],
    files: [],
    effectiveStartDate: null,
    effectiveEndDate: null,
    effectiveStartDateMenu: false,
    effectiveEndDateMenu: false,
    confirmDialog: {
      show: false,
      type: 'info', // success, error, warning, info
      title: '',
      text: '',
      showCancel: false,
      confirmText: '',
      cancelText: '',
      autoClose: false,
      timer: null,
      resolve: null
    },
    errorMessages: {
      columns: []
    }
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('DataIntegrationDetail');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('DataIntegrationDetail'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('DataIntegrationDetail'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('DataIntegrationDetail'));
    },
    // Filter Process Type options by permission:
    //   - 'Add'    (deleteAll=false) requires canAdd OR canEdit (edit implies the ability to add)
    //   - 'Replace' (deleteAll=true)  requires canEdit only (destructive — wipes existing data)
    filteredModeType() {
      const result = [];
      for (const opt of this.modeType) {
        if (opt.value === false && (this.canAdd || this.canEdit)) result.push(opt);
        else if (opt.value === true && this.canEdit) result.push(opt);
      }
      return result;
    },
    formattedEffectiveStartDate() {
      if (!this.effectiveStartDate) return '';
      return moment(this.effectiveStartDate).format('DD/MM/YYYY');
    },
    formattedEffectiveEndDate() {
      if (!this.effectiveEndDate) return '';
      return moment(this.effectiveEndDate).format('DD/MM/YYYY');
    },
  },
  watch: {
    options: {
      handler() {
        if (this.allowOptionWatch) {
          this.GetTable();
        }
      },
      deep: true,
    },
    // Keep deleteAll in sync with filtered Process Type options:
    //   - empty list (no canAdd & no canEdit) → null, dropdown disabled
    //   - current value not allowed              → snap to first allowed value
    filteredModeType: {
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          this.deleteAll = null;
        } else if (!newVal.some(o => o.value === this.deleteAll)) {
          this.deleteAll = newVal[0].value;
        }
      },
    },
  },
  methods: {
    getFuzzyValue(item) {
      if (item.fuzzy) return "fuzzy";
      if (item.fuzzyBot) return "fuzzyBot";
      return "none";
    },

    setFuzzyValue(item, value) {
      // Set the selected option
      if (value === "fuzzy") {
        item.fuzzy = true;
      } else if (value === "fuzzyBot") {
        item.fuzzyBot = true;
      }else{
        // Reset all fuzzy options
        item.fuzzy = false;
        item.fuzzyBot = false;
      }
    },

    getFuzzyIcon(itemOrOption) {
      if (itemOrOption.icon) return itemOrOption.icon; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return "mdi-magnify";
      if (itemOrOption.fuzzyBot) return "mdi-robot";
      return "mdi-close-circle-outline";
    },

    getFuzzyColor(itemOrOption) {
      if (itemOrOption.color) return itemOrOption.color; // For dropdown options

      // For actual items
      if (itemOrOption.fuzzy) return "primary";
      if (itemOrOption.fuzzyBot) return "success";
      return "grey";
    },
    toggleFuzzy(item) {
      // ตรวจสอบว่าสามารถคลิฝได้หรือไม่
      if (this.type == "I" && item.typeId != "nvarchar") {
        return;
      }

      // Toggle fuzzy และปิด fuzzyBot (เพื่อให้ทำงานแบบ radio)
      item.fuzzy = !item.fuzzy;
      if (item.fuzzy) {
        item.fuzzyBot = false;
      }
    },

    toggleFuzzyBot(item) {
      // ตรวจสอบว่าสามารถคลิฝได้หรือไม่
      if (this.type == "I" && item.typeId != "nvarchar") {
        return;
      }

      // Toggle fuzzyBot และปิด fuzzy (เพื่อให้ทำงานแบบ radio)
      item.fuzzyBot = !item.fuzzyBot;
      if (item.fuzzyBot) {
        item.fuzzy = false;
      }
    },

    // Custom dialog methods
    showDialog(options) {
      return new Promise((resolve) => {
        this.confirmDialog = {
          show: true,
          type: options.icon || 'info',
          title: options.title || '',
          text: options.text || '',
          showCancel: options.showCancelButton || false,
          confirmText: options.confirmButtonText || this.$t('confirm'),
          cancelText: options.cancelButtonText || this.$t('cancel'),
          autoClose: options.timer ? true : false,
          resolve: resolve
        };

        if (options.timer) {
          this.confirmDialog.timer = setTimeout(() => {
            this.closeDialog();
            resolve({ isConfirmed: false });
          }, options.timer);
        }
      });
    },

    handleConfirmOk() {
      if (this.confirmDialog.timer) {
        clearTimeout(this.confirmDialog.timer);
      }
      const resolve = this.confirmDialog.resolve;
      this.closeDialog();
      if (resolve) resolve({ isConfirmed: true });
    },

    handleConfirmCancel() {
      if (this.confirmDialog.timer) {
        clearTimeout(this.confirmDialog.timer);
      }
      const resolve = this.confirmDialog.resolve;
      this.closeDialog();
      if (resolve) resolve({ isConfirmed: false });
    },

    closeDialog() {
      this.confirmDialog.show = false;
      this.confirmDialog.resolve = null;
      if (this.confirmDialog.timer) {
        clearTimeout(this.confirmDialog.timer);
        this.confirmDialog.timer = null;
      }
    },

    getConfirmIcon(type) {
      const icons = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information',
        delete: 'mdi-delete'
      };
      return icons[type] || icons.info;
    },

    getConfirmColor(type) {
      const colors = {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'primary',
        delete: 'error'
      };
      return colors[type] || colors.info;
    },

    getConfirmActionIcon(type) {
      const icons = {
        success: 'mdi-check',
        error: 'mdi-close',
        warning: 'mdi-check',
        info: 'mdi-check',
        delete: 'mdi-delete'
      };
      return icons[type] || icons.info;
    },

    triggerFileUpload() {
      // ฝดที่ DragDropFile component ผ่าน ref
      if (this.$refs.dragDropFileRef) {
        // หาค element ที่เป็น input file หรือ button ใน DragDropFile component
        const fileInput =
          this.$refs.dragDropFileRef.$el.querySelector('input[type="file"]');
        const uploadButton =
          this.$refs.dragDropFileRef.$el.querySelector("button");

        if (fileInput) {
          fileInput.click();
        } else if (uploadButton) {
          uploadButton.click();
        }
        // หรือถ้า DragDropFile มี method เปิด dialog
        // this.$refs.dragDropFileRef.openDialog();
      }
    },
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    // Format date for API submission using local timezone (not UTC)
    // This prevents timezone offset issues
    formatDateForAPI(dateValue) {
      if (!dateValue) return null;
      const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
      if (isNaN(d.getTime())) return null;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    back() {
      let self = this;
      self.$router.push({
        name: "DataIntegration",
      });
    },
    async Get() {
      let self = this;
      self.dialog = true;
      self.$call.GetDataIntegrationDetail(
        self.id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DataIntegrationName = dataResponse.data.dataName;
            self.DataCol = dataResponse.data.dataJson;
            self.type = dataResponse.data.type;
            self.effectiveStartDate = dataResponse.data.effectiveStartDate;
            self.effectiveEndDate = dataResponse.data.effectiveEndDate;
            self.headers = dataResponse.data.dataJson.map((e) => ({
              title: e.col,
              align: "center",
              sortable: false,
            }));
            if (self.type == "I") {
              self.headers.push({
                title: self.$t("manage"),
                align: "center",
                sortable: false,
              });
            }
            self.GetTable();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    async GetTable() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage } = self.options;
      // self.sortBy = self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
      // self.sortDesc = self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
      let request = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage,
        ID: self.id,
        Search: self.Search,
      };
      self.$call.GetTableDataIntegrationDetail(
        request,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data.flag) {
              self.searchTotalTable = dataResponse.data.total;
              // self.totalTable = self.isFirst ? dataResponse.data.total : self.searchTotalTable;
              self.dataTable = dataResponse.data.data;
              let indexDateTime = [];
              for (let i = 0; i < self.DataCol.length; i++) {
                if (self.DataCol[i].typeId == "datetime") {
                  indexDateTime.push(i);
                }
              }
              // if (indexDateTime.length > 0) {
              //   for (let i = 0; i < self.dataTable.length; i++) {
              //     for (let j = 0; j < indexDateTime.length; j++) {
              //       if (self.dataTable[i][indexDateTime[j]] != null && self.dataTable[i][indexDateTime[j]] != undefined && self.dataTable[i][indexDateTime[j]] != '') {
              //         self.dataTable[i][indexDateTime[j]] = self.convertDateTimeToString(self.dataTable[i][indexDateTime[j]]);
              //       }
              //     }
              //   }
              // }
              if (indexDateTime.length > 0) {
                for (let i = 0; i < self.dataTable.length; i++) {
                  for (let j = 0; j < indexDateTime.length; j++) {
                    const dateValue = self.dataTable[i][indexDateTime[j]];
                    if (dateValue) {
                      self.dataTable[i][indexDateTime[j]] =
                        self.Utc2Thai(dateValue);
                    }
                  }
                }
              }
              self.allowOptionWatch = true;
            } else {
              await this.showDialog({
                icon: "warning",
                title: self.$t("_Connection_failed"),
                text: self.$t("_Please_check_internet"),
                timer: 1500,
              });
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    GetSearch() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.GetTable();
    },
    async DeleteData(data) {
      let self = this;
      let request = {
        ID: self.id,
        Data: data,
      };
      try {
        const result = await this.showDialog({
          title: this.$t("confirmDeletion"),
          text: this.$t("confirmDeletionVector"),
          icon: "delete",
          showCancelButton: true,
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        });

        if (result.isConfirmed) {
          self.dialog = true;
          self.$call.DeleteDataDataIntegrationDetail(
            request,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                await this.showDialog({
                  icon: "success",
                  title: dataResponse.message,
                  timer: 1500,
                });
                self.GetTable();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteData");
      }
    },
    async SaveAddDetail() {
      let self = this;
      if (self.NewDataDetail.length != self.DataCol.length) {
        await this.showDialog({
          icon: "warning",
          title: self.$t("warningFillAll"),
          timer: 2500,
        });
        return;
      }
      try {
        let request = {
          ID: self.id,
          NewData: self.NewDataDetail,
        };
        self.dialog = true;
        self.$call.AddDataDataIntegrationDetail(
          request,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              await this.showDialog({
                icon: "success",
                title: dataResponse.message,
                timer: 1500,
              });
              self.Adddialog = false;
              self.OldDataDetail = [];
              self.NewDataDetail = [];
              self.totalTable = self.totalTable + 1;
              self.GetTable();
            }else {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');
        console.log("catch : UpdateData");
      }
    },
    async SaveEdit() {
      let self = this;
      if (self.NewDataDetail.length != self.DataCol.length) {
        await this.showDialog({
          icon: "warning",
          title: self.$t("warningFillAll"),
          timer: 2500,
        });
        return;
      }
      try {
        let request = {
          ID: self.id,
          OldData: self.OldDataDetail,
          NewData: self.NewDataDetail,
        };
        self.dialog = true;
        self.$call.UpdateDataDataIntegrationDetail(
          request,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              await this.showDialog({
                icon: "success",
                title: dataResponse.message,
                timer: 1500,
              });
              self.Editdialog = false;
              self.OldDataDetail = [];
              self.NewDataDetail = [];
              self.totalTable = self.totalTable + 1;
              self.GetTable();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : UpdateData");
      }
    },
    AddData() {
      let self = this;
      self.Adddialog = true;
      // self.NewDataDetail = data;
    },
    EditData(data) {
      let self = this;
      self.Editdialog = true;
      self.OldDataDetail = data;
      self.NewDataDetail = JSON.parse(JSON.stringify(data));
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Utc2Thai(Input) {
      var utc = new Date(Input);
      //var local = new Date(utc.getTime() + 7 * 60 * 60 * 1000);
      var day = String(utc.getDate()).padStart(2, "0");
      var month = String(utc.getMonth() + 1).padStart(2, "0");
      var year = String(utc.getFullYear()).slice();
      // var hours = String(utc.getHours()).padStart(2, '0');
      // var minutes = String(utc.getMinutes()).padStart(2, '0');
      // // Format the date as yyyy/mm/dd hh:mm
      // return `${year}/${month}/${day} ${hours}:${minutes}`;
      return `${year}-${month}-${day}`;
    },
    validatecolumn() {
      let self = this;
      if (
        self.DataCol.filter((e) => e.newCol == "" || e.newCol == null).length >
        0
      ) {
        return "Please Fill All The Fields!";
      }

      for (let i = 0; i < self.DataCol.length; i++) {
        let item = self.DataCol[i];
        let tmpCol = item.newCol;
        let count = self.DataCol.filter((e) => e.newCol == tmpCol).length;
        if (count > 1) {
          return "Column Duplicate!";
        }
      }
      return null;
    },

    async validateColumnNameAndType(ind) {
      let self = this;
      self.dialog = true;
      if(self.DataCol[ind].newCol == "" || self.DataCol[ind].newCol == null) {
        await this.showDialog({
          icon: 'warning',
          title: 'Column name is required!',
          text: 'Please fill in the column name.',
          confirmButtonText: 'Okay',
        });
        self.dialog = false;
        return;
      }
      let duplicateCheck = self.DataCol.filter(
        (e) => e.newCol == self.DataCol[ind].newCol
      );
      if (duplicateCheck.length > 1) {
        await this.showDialog({
          icon: 'error',
          title: 'Column name already exists!',
          text: 'Please choose a different column name.',
          confirmButtonText: 'Okay',
        });
        self.dialog = false;
        return;
      }
      let temp = {
        id: self.id,
        ColumnChecklist: [self.DataCol[ind].newCol]
      };
      self.$call.ValidateExternalColumn(
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DataCol[ind].typeId = dataResponse.data.columns[0].dataType;
            await this.showDialog({
              icon: 'success',
              title: dataResponse.data.message || 'Column validation completed successfully!',
              timer: 1500,
            });
          } else {
            await this.showDialog({
              icon: 'error',
              title: 'Column validation failed!',
              text: dataResponse.data.message || 'Column validation failed!',
              confirmButtonText: 'Okay',
            });
          }
          self.dialog = false;
        },
        async (errorResource) => {
          self.dialog = false;
          await this.showDialog({
            icon: 'error',
            title: 'Error occurred during column validation!',
            text: errorResource.message || 'Please try again later.',
            confirmButtonText: 'Okay',
          });
          console.error(errorResource);
        }
      );
    },

    validatecDataType() {
      let self = this;
      if (self.type == "E") {
        return null;
      }
      if (
        self.DataCol.filter((e) => e.typeId == "" || e.typeId == null).length >
        0
      ) {
        return "Please Fill All The Data Type!";
      }
      return null;
    },

    async Save() {
      let self = this;
      let spaceText = false;
      // Check if there are any columns with empty or null typeid
      self.DataCol.map((item,index) => {

        if (this.errorMessages.columns.length <= index) {
          this.errorMessages.columns.push({ error: false, message: '' });
        }

        const splitText = item.newCol.split(' ');
        this.errorMessages.columns[index].error = false;
        this.errorMessages.columns[index].message = '';
        if (splitText.length > 1 && (splitText[0] === '' || splitText[splitText.length - 1] === '')) {
          this.errorMessages.columns[index].error = true;
          this.errorMessages.columns[index].message = 'Column name cannot have leading or trailing spaces!';
          spaceText = true;
        }
        if (item.name !== null && item.name !== undefined && item.name !== '') {
          tempCheckColumns.push(item);
          headers.push(item.name);
        }
      });
      
      if (spaceText) {
        return;
      }


      if (self.DataCol.filter((e) => e.typeId == "" || e.typeId == null).length > 0) {
        await this.showDialog({
          icon: "warning",
          title: "Please validate all columns\nbefore saving.",
          timer: 2500,
        });
        return;
      }

      const result = await this.showDialog({
        icon: "warning",
        title: this.$t("_ConfirmDataUpdate"),
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel"),
      });

      if (result.isConfirmed) {
        let flagColumn = self.validatecolumn();
        let flagDataType = self.validatecDataType();
        if (flagColumn == null && flagDataType == null) {
          self.dialog = true;
          let temp = {
            ID: self.id,
            DataJson: self.DataCol,
            EffectiveStartDate: self.formatDateForAPI(self.effectiveStartDate),
            EffectiveEndDate: self.formatDateForAPI(self.effectiveEndDate),
            ActiveStatus: true,
          };
          try {
            self.$call.UpdateDataIntegration(
              temp,
              async (dataResponse) => {
                if (dataResponse.status == 0) {
                  await this.showDialog({
                    icon: "success",
                    title: dataResponse.message,
                    timer: 1500,
                  });
                  this.GetTable();
                  // self.back();
                } else {
                  await this.showDialog({
                    icon: "error",
                    title: "Error occurred",
                    text: dataResponse.message.length > 100
                      ? dataResponse.message.substring(0, 100) + "..."
                      : dataResponse.message,
                    showCancelButton: false,
                    confirmButtonText: this.$t("close"),

                  });
                }
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                self.AddVector = false;
                console.error(errorResource);
              }
            );
          } catch (error) {
            this.LogTrace(error, "DeleteGroup");
          }
        } else if (flagColumn != null) {
          alert(flagColumn);
          self.dialog = false;
          // self.$swal.fire({
          //   icon: 'error',
          //   title: flagColumn,
          //   showConfirmButton: false,
          //   timer: 3500,
          // });
        } else {
          alert(flagDataType);
          self.dialog = false;
          // self.$swal.fire({
          //   icon: 'error',
          //   title: flagDataType,
          //   showConfirmButton: false,
          //   timer: 3500,
          // });
        }
      }
    },
    async GetModelData() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLModelData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
            self.DDModelShow = self.listDDModel.filter(
              (e) => e.provider == "Azure"
            );
          } else {
            self.listDDModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    processUpload(e) {
      let self = this;
      this.files = e;
      if (this.files.length == 0) {
        this.Entity = null;
        this.uploadedFiles = [];
        return;
      }
      self.DataRowUpload = [];
      const reader = new FileReader();
      const file = this.files[0];
      reader.onload = async (event) => {
        const buffer = event.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        // Get the first worksheet
        const worksheet = workbook.getWorksheet(1);
        if (!worksheet) {
          await this.showDialog({
            icon: "error",
            title: "No worksheet found in the Excel file",
            timer: 2500,
          });
          return;
        }

        // Extract data from the worksheet
        const jsonData = [];
        const headers = [];

        // Get headers from the first row
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          headers.push(cell.value);
        });
        jsonData.push(headers);

        // Get data from remaining rows
        let rowCount = 1; // Start from the second row (after headers)
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          const rowData = [];
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            rowData[colNumber - 1] = cell.value || "";
          });

          // Ensure rowData has the same length as headers
          while (rowData.length < headers.length) {
            rowData.push("");
          }

          jsonData.push(rowData);
          rowCount++;
        });

        // Process the data
        self.DataRowUpload = jsonData.slice(1);
        let listindexnamefuzzy = [];
        self.DataCol.forEach((item) => {
          if (item.fuzzy == true || item.fuzzyBot == true) {
            let index = headers.indexOf(item.newCol);
            listindexnamefuzzy.push(index);
          }
        });

        self.totalTable += jsonData.length - 1;
        let chkValidateLimitFuzzy = self.ValidateLimitFuzzy(
          headers,
          listindexnamefuzzy
        );

        if (self.ValidateColumns(headers)) {
          await this.showDialog({
            icon: "error",
            title: self.$t("_duplicateColumn"),
            timer: 2500,
          });
        } else if (
          !self.arraysEqual(
            self.DataCol.map((e) => e.newCol),
            headers
          )
        ) {
          await this.showDialog({
            icon: "error",
            title: self.$t("_incorrectColumn"),
            timer: 2500,
          });
        } else if (chkValidateLimitFuzzy != null) {
          await this.showDialog({
            icon: "warning",
            title: chkValidateLimitFuzzy,
            confirmButtonText: this.$t('confirm'),
          });
          return;
        } else {
          this.MapData(self.files);
          this.ConfirmProcess();
        }
      };
      reader.readAsArrayBuffer(file);
    },
    ValidateLimitFuzzy(headers, listindexnamefuzzy) {
      let self = this;
      for (let j = 0; j < listindexnamefuzzy.length; j++) {
        let indexcol = listindexnamefuzzy[j];
        for (let i = 0; i < self.DataRowUpload.length; i++) {
          let tmpdata = self.DataRowUpload[i][indexcol];
          if (tmpdata.length > 800) {
            return (
              "The data in column " +
              headers[indexcol] +
              ", row " +
              (i + 2) +
              " exceeds the limit of 800 characters."
            );
          }
        }
      }
      return null;
    },
    ValidateColumns(columns) {
      const uniqueColumns = [...new Set(columns)];
      if (uniqueColumns.length !== columns.length) {
        return true; //มี Header ซ้ำ
      }
      return false;
    },
    arraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      let sortedArr1 = arr1.slice().sort();
      let sortedArr2 = arr2.slice().sort();

      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) return false;
      }

      return true;
    },
    MapData(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("uploaded_file", files[0]);
      //console.log(files[0]);
      this.uploadedFiles = files;
      this.Entity = formDataDoc;
    },
    async ConfirmProcess() {
      let self = this;
      const result = await this.showDialog({
        icon: "warning",
        title: this.$t("ImportDataIntegration"),
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel"),
      });

      if (result.isConfirmed) {
        self.SaveData();
      }
    },
    async SaveData() {
      let self = this;
      self.dialog = true;
      let temp = {
        id: self.id,
        uploaded_file: self.Entity,
        deleteAll: self.deleteAll,
      };
      try {
        self.$call.AddDataIntegration_Data(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              await this.showDialog({
                icon: "success",
                title: dataResponse.message,
                timer: 1500,
              });
              self.GetTable();
              self.AddDataIntegration = false;
              // self.Get();
            } else {
              await this.showDialog({
                icon: "error",
                title: dataResponse.message,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    convertToDate(dateString) {
      // แยฝวันที่ เวลา และส่วนต่างๆ
      const parts = dateString.split(" ");
      const dateParts = parts[0].split("/");
      const timeParts = parts[1].split(":");

      // แปลงปีจากพุทธศัฝราชเป็นคริสต์ศัฝราช
      let day = parseInt(dateParts[0], 10);
      let month = parseInt(dateParts[1], 10) - 1; // เดือนใน JavaScript เริ่มจาก 0
      let year = parseInt(dateParts[2], 10); // แปลงพุทธศัฝราชเป็นคริสต์ศัฝราช

      // สร้าง Date object
      return new Date(
        year,
        month,
        day,
        parseInt(timeParts[0], 10),
        parseInt(timeParts[1], 10),
        parseInt(timeParts[2], 10)
      );
    },
    DeleteAction(index) {
      let self = this;
      if (index > -1 && index < self.DataCol.length) {
        self.DataCol.splice(index, 1);
      }
    },
    AddColumn() {
      let self = this;

      let temp = {
        col: "",
        newCol: "",
        typeId: "",
        fuzzy: false,
        fuzzyBot: false,
        personalInformation: false,
      };
      self.DataCol.push(temp);
    },
    transformValue(value) {
      if (typeof value === "string") {
        value = value.toLowerCase();
      }
      if (value === 1 || value === true || value === "true") {
        return "True";
      } else if (value === 0 || value === false || value === "false") {
        return "False";
      }
      return null; // ฝรณีที่ค่าไม่ตรงฝับสิ่งที่ต้องการ จัดการตามที่เห็นสมควร เช่น return null
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    if (self.$route.query.id) {
      self.id = self.$route.query.id;
      await self.Get();
    }
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.data-table-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
}

.table-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 16px 24px !important;
  border-bottom: 1px solid #dee2e6;
}

.modern-table {
  background: white;
}

.table-header-cell {
  background: transparent !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 16px 12px !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2) !important;
  position: relative;
  text-align: center;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f3f4;
}

.table-row:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e3f2fd 100%) !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-cell {
  padding: 12px !important;
  vertical-align: middle !important;
  border-bottom: 1px solid #f1f3f4 !important;
}

.cell-content {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.cell-text {
  font-size: 0.875rem;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.action-cell {
  width: 120px;
  background: rgba(248, 249, 250, 0.5);
}

.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.datatable-action-btn) {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.edit-btn:hover {
  transform: scale(1.1);
}

.delete-btn:hover {
  transform: scale(1.1);
}

.table-footer {
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 0;
}

/* Skeleton Loader Styling */
.v-skeleton-loader {
  background: transparent !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header {
    padding: 12px 16px !important;
  }

  .table-header-cell {
    padding: 12px 8px !important;
  }

  .table-cell {
    padding: 8px !important;
  }

  .cell-text {
    max-width: 120px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

/* Dark Mode Support */
.v-theme--dark .data-table-card {
  background: #1e1e1e !important;
}

.v-theme--dark .table-header {
  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
  border-bottom: 1px solid #404040;
}

.v-theme--dark .table-row {
  border-bottom: 1px solid #404040;
}

.v-theme--dark .table-row:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%) !important;
}

.v-theme--dark .table-footer {
  background: #2d2d2d;
  border-top: 1px solid #404040;
}

/* Animation for Loading */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modern-table {
  animation: fadeIn 0.3s ease-in;
}

/* Improved Scrollbar */
.modern-table ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modern-table ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.modern-table ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.modern-table ::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Flex layout for better responsive */
.flex {
  margin-left: 1rem;
  margin-right: 1rem;
}

@media (min-width: 1200px) {
  .flex {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

.custom-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 16px;
  background-color: #f9f9f9;
  border-top: 1px solid #e0e0e0;
}
.footer-center {
  margin: 0px 20px;
}

.footer-left,
.footer-center,
.footer-right {
  display: flex;
  align-items: center;
}

.footer-left span,
.footer-center span {
  font-size: 14px;
  color: #555;
}

.transparent-enabled {
  opacity: 0.7;
}
.transparent-enabled:hover {
  opacity: 1;
}
.transparent-disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.table-header-row {
  background: linear-gradient(135deg, #2070a5 0%, #56388e 100%);
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
}
.header-text {
  font-size: 0.875rem;
  letter-spacing: 0.5px;
}
.integration-name-sheet {
  background: #f5f5f5 !important;
  padding: 16px !important;
  border-left: 4px solid #1976d2 !important;
  border-radius: 8px !important;
  margin-left: 20px;
}

.integration-name-label-simple {
  font-size: 0.75rem;
  font-weight: 500;
  color: #666;
  margin-bottom: 2px;
}

.integration-name-value-simple {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

/* Dark theme */
.v-theme--dark .integration-name-sheet {
  background: #2d2d2d !important;
  border-left-color: #64b5f6 !important;
}

.v-theme--dark .integration-name-label-simple {
  color: #bbb;
}

.v-theme--dark .integration-name-value-simple {
  color: #fff;
}
.custom-expansion-title {
  background: rgba(25, 118, 210, 0.05) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
  border-left: 6px solid #1976d2 !important;
  border-radius: 0px 12px 12px 0px !important;
  margin-bottom: 16px !important;
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
  padding-right: 50px;
}

.custom-expansion-title::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(25, 118, 210, 0.1) 0%,
    transparent 50%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.custom-expansion-title:hover::before {
  opacity: 1;
}

.custom-expansion-title:hover {
  border-left-width: 9px !important;
  /* border-color: rgba(25, 118, 210, 0.4) !important; */
  border-left-color: #0d47a1 !important;
  /* box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15) !important; */
}

.expansion-title-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  position: relative;
  z-index: 1;
}

.expansion-header {
  font-size: 1rem !important;
  font-weight: 600 !important;
  color: #1976d2 !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.expansion-icon {
  color: #1976d2 !important;
  transition: all 0.3s ease !important;
}
/* #region Custom Configuration Panels */
.configuration-container {
  padding: 8px;
}

.config-card-wrapper {
  margin-bottom: 16px;
}

.config-card {
  border: 1px solid #e3f2fd !important;
  background: white !important;
  transition: all 0.2s ease;
}

.config-card:hover {
  border-color: #1976d2 !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.1) !important;
}

.config-card-content {
  padding: 16px !important;
}

.config-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.config-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1976d2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.config-fields {
  margin-bottom: 12px;
}

.field-col {
  padding: 0 8px;
}

.field-col:first-child {
  padding-left: 0;
}

.field-col:last-child {
  padding-right: 0;
}

.config-field {
  margin-bottom: 8px;
}

.checkbox-container {
  display: flex;
  gap: 24px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f5f5f5;
}

.config-checkbox {
  flex: 0 0 auto;
}

.config-delete-btn {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.config-delete-btn:hover {
  opacity: 1;
}

.add-column-row {
  margin: 24px 0 16px 0;
}

.add-column-btn {
  height: 48px !important;
  border: 2px dashed #1976d2 !important;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  transition: all 0.2s ease;
}

.add-column-btn:hover {
  background: rgba(25, 118, 210, 0.05) !important;
  border-style: solid !important;
}

/* .config-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
}

.config-action-btn {
  min-width: 120px;
  height: 40px;
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
}
*/

.save-btn {
  background-color: #46b149 !important;
  color: white !important;
  border-radius: 8px;
  width: 120px;
  transition: all 0.2s ease;
}

.save-btn:hover {
  box-shadow: 0 4px 12px rgba(25, 210, 25, 0.3) !important;
} 
/* Responsive Design */
@media (max-width: 768px) {
  .checkbox-container {
    flex-direction: column;
    gap: 8px;
  }

  .config-action-buttons {
    flex-direction: column;
  }

  .field-col {
    padding: 4px 0;
  }
}

/* Dark theme support */
.v-theme--dark .config-card {
  background: #2d2d2d !important;
  border-color: #404040 !important;
}

.v-theme--dark .config-card:hover {
  border-color: #64b5f6 !important;
}

.v-theme--dark .config-header {
  border-bottom-color: #404040;
}

.v-theme--dark .config-title {
  color: #64b5f6;
}

.v-theme--dark .checkbox-container {
  border-top-color: #404040;
}

.v-theme--dark .config-action-buttons {
  border-top-color: #404040;
}
/* #endregion */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 14px;
  align-self: center;
  border-radius: 1px;
}
/* Search Field Styling */
.search-field-container {
  padding: 8px;
}

.search-field {
  border-radius: 12px !important;
  transition: all 0.2s ease;
}

.search-field .v-field {
  border-radius: 12px !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
}

.search-field:focus-within .v-field {
  border-color: #1976d2 !important;
  background: rgba(25, 118, 210, 0.05) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1) !important;
}

.date-field .v-field {
  cursor: pointer;
}

/* Search Action Button */
.search-btn.compact {
  border-radius: 8px !important;
  height: 36px !important;
  font-weight: 500;
  text-transform: none;
  font-size: 0.875rem !important;
  padding: 0 16px !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25) !important;
  transition: all 0.2s ease;
  min-width: 100px;
}

.search-btn.compact:hover {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.35) !important;
  transform: translateY(-1px);
}

.search-btn.compact .v-icon {
  font-size: 16px !important;
}

/* Alternative Minimal Style */
.search-btn.minimal {
  border-radius: 20px !important;
  height: 32px !important;
  font-weight: 500;
  text-transform: none;
  font-size: 0.8rem !important;
  padding: 0 12px !important;
  background: rgba(25, 118, 210, 0.1) !important;
  color: #1976d2 !important;
  border: 1px solid rgba(25, 118, 210, 0.3) !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
  min-width: 80px;
}

.search-btn.minimal:hover {
  background: rgba(25, 118, 210, 0.15) !important;
  border-color: #1976d2 !important;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.2) !important;
}

/* Control Group */
.control-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap !important;
  gap: 12px;
  padding: 8px;
}

.process-type-select {
  min-width: 120px !important;
  border-radius: 12px !important;
}

.process-type-select .v-field {
  border-radius: 12px !important;
  background: rgba(156, 39, 176, 0.02) !important;
  border: 1px solid rgba(156, 39, 176, 0.2) !important;
}

.process-type-select:focus-within .v-field {
  border-color: #9c27b0 !important;
  background: rgba(156, 39, 176, 0.05) !important;
}

.info-icon {
  transition: all 0.2s ease;
}

.info-icon:hover {
  transform: scale(1.2);
  color: #1976d2 !important;
}

.upload-file-btn {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Add Action Button */
.add-action-container {
  display: flex;
  align-items: center;
  padding: 8px;
}

.add-btn {
  border-radius: 12px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
  transition: all 0.2s ease;
  width: 100%;
}

.add-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4) !important;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .control-group {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }

  .process-type-select {
    min-width: auto !important;
  }

  .search-btn,
  .add-btn {
    width: 100%;
    height: 44px !important;
  }
}

/* Dark Theme Support */
.v-theme--dark .search-field .v-field {
  background: rgba(100, 181, 246, 0.05) !important;
  border-color: rgba(100, 181, 246, 0.3) !important;
}

.v-theme--dark .search-field:focus-within .v-field {
  border-color: #64b5f6 !important;
  background: rgba(100, 181, 246, 0.1) !important;
}

.v-theme--dark .process-type-select .v-field {
  background: rgba(186, 104, 200, 0.05) !important;
  border-color: rgba(186, 104, 200, 0.3) !important;
}

.v-theme--dark .process-type-select:focus-within .v-field {
  border-color: #ba68c8 !important;
  background: rgba(186, 104, 200, 0.1) !important;
}

/* Input Animation */
.search-field .v-field__input {
  transition: all 0.2s ease;
}

.search-field:focus-within .v-field__input {
  transform: translateY(-1px);
}

/* Enhanced Icons */
.search-field .v-field__prepend-inner {
  color: #1976d2 !important;
  opacity: 0.7;
}

.search-field:focus-within .v-field__prepend-inner {
  opacity: 1;
  transform: scale(1.1);
}

/* Button Group Styling */
.search-action-container,
.add-action-container {
  height: 100%;
}

/* Enhanced Hover Effects */
.v-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-btn:hover {
  filter: brightness(1.05);
}

/* Field Focus Ring */
.v-field--focused {
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2) !important;
}

/* Upload Proxy Button */
.upload-proxy-btn {
  border-radius: 12px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  background: rgba(33, 115, 70, 0.1) !important;
  color: #217346 !important;
  border: 1px solid rgba(33, 115, 70, 0.3) !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
  min-width: 140px;
}

.upload-proxy-btn:hover {
  background: rgba(33, 115, 70, 0.15) !important;
  border-color: #217346 !important;
  box-shadow: 0 2px 8px rgba(33, 115, 70, 0.2) !important;
  color: #185c37 !important;
}
/* Icon Animation */
.upload-proxy-btn .v-icon {
  transition: all 0.2s ease;
}

.upload-proxy-btn:hover .v-icon {
  transform: translateY(-1px) scale(1.05);
}

/* Loading State (Optional) */
.upload-proxy-btn.loading {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.upload-proxy-btn.loading .v-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Hide the original DragDropFile */
.hidden-upload {
  display: none !important;
  visibility: hidden !important;
  position: absolute !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Control Group Update */
.control-group {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  flex-wrap: wrap; /* เพิ่มเพื่อให้ responsive ดีขึ้น */
}

/* Responsive Design */
@media (max-width: 768px) {
  .upload-proxy-btn {
    width: 100%;
    height: 44px !important;
    min-width: auto;
  }
}
/* Fuzzy Dropdown Styling */
.fuzzy-dropdown-container {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.fuzzy-select {
  max-width: 300px;
}

.fuzzy-select .v-field {
  border-radius: 8px !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
  transition: all 0.2s ease;
}

.fuzzy-select:focus-within .v-field {
  border-color: #1976d2 !important;
  background: rgba(25, 118, 210, 0.05) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1) !important;
}

.selection-content {
  display: flex;
  align-items: center;
}

.selection-text {
  font-size: 0.875rem;
  font-weight: 500;
}

.label-content {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
}

.fuzzy-list-item {
  padding: 8px 16px !important;
  transition: all 0.2s ease;
}

.fuzzy-list-item:hover {
  background: rgba(25, 118, 210, 0.05) !important;
}

.fuzzy-item-title {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  margin-bottom: 2px !important;
}

.fuzzy-item-subtitle {
  font-size: 0.75rem !important;
  opacity: 0.8 !important;
  line-height: 1.3 !important;
}

/* Compact Version */
.fuzzy-dropdown-container.compact {
  margin-top: 8px;
  padding-top: 8px;
}

.fuzzy-dropdown-container.compact .fuzzy-select {
  max-width: 250px;
}

.fuzzy-dropdown-container.compact .fuzzy-item-subtitle {
  display: none;
}

/* Dark Theme Support */
.v-theme--dark .fuzzy-select .v-field {
  background: rgba(100, 181, 246, 0.05) !important;
  border-color: rgba(100, 181, 246, 0.3) !important;
}

.v-theme--dark .fuzzy-select:focus-within .v-field {
  border-color: #64b5f6 !important;
  background: rgba(100, 181, 246, 0.1) !important;
}

.v-theme--dark .fuzzy-list-item:hover {
  background: rgba(100, 181, 246, 0.1) !important;
}

.v-theme--dark .label-content {
  color: #bbb;
}

.v-theme--dark .fuzzy-dropdown-container {
  border-top-color: #404040;
}

/* Enhanced Dropdown Animation */
.v-overlay__content {
  animation: dropdownSlide 0.2s ease-out;
}

@keyframes dropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom Scrollbar for Dropdown */
.v-list {
  max-height: 200px;
  overflow-y: auto;
}

.v-list::-webkit-scrollbar {
  width: 6px;
}

.v-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.v-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.v-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.modern-dialog-card {
  overflow: hidden !important;
  background: white !important;
  border: none !important;
}

.modern-dialog-header {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  color: white !important;
  padding: 24px !important;
  margin: 0 !important;
  position: relative;
  overflow: hidden;
}

.modern-dialog-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  pointer-events: none;
}

.modern-dialog-header.edit-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
}

.header-content {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.header-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  backdrop-filter: blur(10px);
  border: 2px dashed rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.header-icon-wrapper.edit-icon {
  background: rgba(255, 255, 255, 0.15);
}

.header-text-wrapper {
  flex: 1;
}

.dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  margin: 0 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  opacity: 0.9;
  margin: 4px 0 0 0 !important;
  font-weight: 400;
}

.modern-dialog-content {
  padding: 32px 24px !important;
  background: #fafafa !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.dialog-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  overflow: hidden;
}

.dialog-actions {
  flex: 0 0 auto;
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.form-grid {
  margin: 0 -12px;
}

.form-column {
  padding: 0 12px 16px 12px;
}

.field-container {
  position: relative;
}

.modern-field {
  margin-bottom: 8px;
}

.modern-field .v-field {
  border-radius: 12px !important;
  background: #fafafa !important;
  border: 2px solid #e3f2fd !important;
  transition: all 0.3s ease;
}

.modern-field:focus-within .v-field {
  border-color: #1976d2 !important;
  background: white !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
  transform: translateY(-1px);
}

.modern-field .v-field__prepend-inner {
  color: #1976d2 !important;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.modern-field:focus-within .v-field__prepend-inner {
  opacity: 1;
  transform: scale(1.1);
}

.date-field .v-field {
  cursor: pointer;
}

.modern-date-picker {
  border-radius: 16px !important;
  overflow: hidden;
}

.modern-divider {
  border-color: #e0e0e0 !important;
  margin: 0 !important;
}

.modern-dialog-actions {
  padding: 20px 24px 24px 24px !important;
  background: white !important;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
}

/* .dialog-action-btn {
  min-width: 120px !important;
  height: 48px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  transition: all 0.3s ease !important;
}

.dialog-cancel-btn {
  border: 2px solid #bdbdbd !important;
  color: #757575 !important;
}

.dialog-cancel-btn:hover {
  background: #f5f5f5 !important;
  border-color: #9e9e9e !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.dialog-save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
}

.dialog-save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4) !important;
}

.dialog-edit-save-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3) !important;
}

.dialog-edit-save-btn:hover {
  box-shadow: 0 6px 16px rgba(33, 150, 243, 0.4) !important;
} */

/* Loading Animation for Save Button */
.dialog-action-btn.loading {
  opacity: 0.8;
  pointer-events: none;
}

.dialog-action-btn.loading .v-icon {
  animation: spin 1s linear infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-dialog-header {
    padding: 20px 16px !important;
  }

  .header-icon-wrapper {
    width: 50px;
    height: 50px;
    margin-right: 16px;
  }

  .dialog-title {
    font-size: 1.25rem !important;
  }

  .modern-dialog-content {
    padding: 24px 16px !important;
  }

  .form-container {
    padding: 16px;
  }

  .form-grid {
    margin: 0 -8px;
  }

  .form-column {
    padding: 0 8px 12px 8px;
  }

  .actions-container {
    flex-direction: column;
  }

  .dialog-action-btn {
    width: 100% !important;
  }
}

/* Dark Theme Support */
.v-theme--dark .modern-dialog-card {
  background: #2d2d2d !important;
}

.v-theme--dark .modern-dialog-content {
  background: #1a1a1a !important;
}

.v-theme--dark .form-container {
  background: #2d2d2d;
  border-color: #404040;
}

.v-theme--dark .modern-field .v-field {
  background: #1a1a1a !important;
  border-color: rgba(100, 181, 246, 0.3) !important;
}

.v-theme--dark .modern-field:focus-within .v-field {
  border-color: #64b5f6 !important;
  background: #2d2d2d !important;
}

.v-theme--dark .modern-dialog-actions {
  background: #2d2d2d !important;
}

.v-theme--dark .cancel-btn {
  border-color: #555 !important;
  color: #bbb !important;
}

.v-theme--dark .cancel-btn:hover {
  background: #404040 !important;
  border-color: #777 !important;
}

/* Animation for Dialog Entrance */
.v-dialog > .v-overlay__content {
  animation: dialogSlideIn 0.3s ease-out;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Field Validation Styling */
.v-field--error .v-field__outline {
  border-color: #f44336 !important;
}

.v-field--error .v-field__prepend-inner {
  color: #f44336 !important;
}

/* Enhanced Focus States */
.modern-field .v-field__input {
  transition: all 0.2s ease;
}

.modern-field:focus-within .v-field__input {
  color: #1976d2 !important;
}

/* Floating Label Animation */
.modern-field .v-field__label {
  transition: all 0.3s ease;
}

.modern-field:focus-within .v-field__label,
.modern-field .v-field__label--active {
  color: #1976d2 !important;
  font-weight: 600 !important;
}
.fuzzy-personal-container {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.fuzzy-dropdown-wrapper {
  padding-right: 8px;
  min-width: 300px;
}

.personal-info-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
}

.personal-info-container {
  background-color: #fffbf2;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 4px 12px;
  width: 100%;
  transition: all 0.2s ease;
}

.personal-info-container:hover {
  background-color: #fff8e5;
  border-color: #ffe8a1;
}

.personal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.personal-info-label {
  display: flex;
  align-items: center;
  cursor: help;
}

.personal-info-switch {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.personal-info-switch :deep(.v-switch__track) {
  opacity: 0.4;
}

.status-on {
  font-weight: 700;
  color: #ff9800;
}

.status-off {
  font-weight: 500;
  color: #757575;
}
.validate-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 40px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  background: rgba(25, 118, 210, 0.05);
  transition: all 0.2s ease;
  font-weight: 500;
  color: #1976d2;
}

.validate-button:hover {
  background: rgba(25, 118, 210, 0.1);
  border-color: #0d47a1;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .fuzzy-dropdown-wrapper {
    padding-right: 0;
    margin-bottom: 8px;
  }
  
  .personal-info-wrapper {
    padding-left: 0;
  }
}

/* Confirm Dialog Styles */
.confirm-dialog .v-overlay__content {
  animation: dialogBounceIn 0.3s ease-out;
}

@keyframes dialogBounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-50px);
  }
  50% {
    opacity: 1;
    transform: scale(1.05) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}

.confirm-card {
  overflow: hidden !important;
  border: none !important;
}

.confirm-header {
  padding: 24px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.success-header {
  background: #4caf50 !important;
  color: white !important;
}

.error-header {
  background: #f44336 !important;
  color: white !important;
}
.delete-header {
  background: #f44336 !important;
  color: white !important;
}

.warning-header {
  background: #ff9800 !important;
  color: white !important;
}

.info-header {
  background: #2196f3 !important;
  color: white !important;
}

.confirm-icon-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.confirm-title-text h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.confirm-content {
  padding: 20px 24px !important;
  background: #fafafa;
}

.confirm-message {
  font-size: 1rem;
  line-height: 1.5;
  color: #555;
  margin: 0;
  text-align: center;
}

.confirm-actions {
  padding: 16px 24px 24px 24px !important;
  background: white;
}

.confirm-btn {
  min-width: 100px !important;
  height: 40px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  transition: all 0.2s ease !important;
}

.cancel-btn {
  border: 2px solid #bdbdbd !important;
  color: #757575 !important;
}

.cancel-btn:hover {
  background: #f5f5f5 !important;
  border-color: #9e9e9e !important;
  transform: translateY(-1px);
}

.confirm-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

/* Auto-close timer indicator */
.confirm-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.7);
  animation: timerProgress linear;
}

/* Dark theme support */
.v-theme--dark .confirm-content {
  background: #1a1a1a;
}

.v-theme--dark .confirm-message {
  color: #bbb;
}

.v-theme--dark .confirm-actions {
  background: #2d2d2d;
}

.v-theme--dark .cancel-btn {
  border-color: #555 !important;
  color: #bbb !important;
}

.v-theme--dark .cancel-btn:hover {
  background: #404040 !important;
  border-color: #777 !important;
}

/* Responsive design */
@media (max-width: 600px) {
  .confirm-header {
    padding: 20px 16px !important;
    flex-direction: column;
    text-align: center;
  }

  .confirm-icon-container {
    margin-right: 0;
    margin-bottom: 12px;
  }

  .confirm-content {
    padding: 16px !important;
  }

  .confirm-actions {
    padding: 12px 16px 16px 16px !important;
    flex-direction: column;
    gap: 8px;
  }

  .confirm-btn {
    width: 100% !important;
  }
}
</style>
